import { Injectable } from '@angular/core';
import { apiService } from './api.service';
import { HttpHeaders } from '@angular/common/http';
import { customerService } from './customer.service';

@Injectable({
  providedIn: 'root',
})

export class globalData {
  constructor(private _apiService: apiService,
    private _customerService: customerService) { }

  public isUserLogin: boolean = localStorage.getItem('isUserLogin') && localStorage.getItem('isUserLogin') == 'true' ? true : false;
  public loginUserName: any = localStorage.getItem('loginUserName');
  public loginUserId: any = localStorage.getItem('loginUserId');
  public auth_token: any = localStorage.getItem('loginUserToken');
  countryCodes: any[] = [];
  arabicCounties: any[] = [];
  stateList: any[] = [];
  cityList: any[] = [];
  public customerRegionCode: any = localStorage.getItem('customerRegionCode');
  public customerCountryCode: any = localStorage.getItem('customerCountryCode');
  public customerISDCode: any = localStorage.getItem('customerISDCode');
  public isCustomerLanguageChange: boolean = localStorage.getItem('isLanguageCodeChange') && localStorage.getItem('isLanguageCodeChange') == '1' ? true : false;
  public LanguageCode: any = '';

  userSignout() {

    const bodyParam = {
      "device_id": ''
    };

    this._customerService.customerLogout(bodyParam).subscribe(response => {
      if (response.success == true) {
        this.clearCustomerSession();
      }
    });
  }

  clearCustomerSession() {
    this.loginUserName = '';
    this.isUserLogin = false;
    this.loginUserId = '';
    this.auth_token = '';

    localStorage.setItem('isUserLogin', '');
    localStorage.setItem('loginUserName', '');
    localStorage.setItem('loginUserId', '');
    localStorage.setItem('loginUserToken', '');
  }

  closeCustomerAccount() {

    const bodyParam = {
      "language_code": localStorage.getItem('languageCode'),
      "deleted_reason": 'test'
    };

    this._customerService.closeCustomerAccount(bodyParam).subscribe(response => {
      if (response.success == true) {
        this.loginUserName = '';
        this.isUserLogin = false;
        this.loginUserId = '';
        this.auth_token = '';

        localStorage.setItem('isUserLogin', '');
        localStorage.setItem('loginUserName', '');
        localStorage.setItem('loginUserId', '');
        localStorage.setItem('loginUserToken', '');
      }
    });
  }

  GetCountryList(searchText: string): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
      this.countryCodes = [];

      this._apiService.getCountryList(searchText, 100).subscribe(
        (data) => {
          let countryList = data.data;
          if (countryList.data) {
            countryList.data.forEach((element: any) => {
              if (element.status == "active") {
                this.countryCodes.push({
                  id: element.id,
                  isd_code: element.isd_code,
                  iso_code: element.iso_code,
                  mobNo_length: element.max_mobile_number_length,
                  country_en: localStorage.getItem('languageCode') == 'ar' ? element.country_ar : element.country_en
                });
              }
            });
          }
          resolve(this.countryCodes);
        }
      );
    });
  }

  GetStateList(country: string, searchText: string): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
      this.stateList = [];

      this._apiService.getStateList(country, searchText).subscribe(
        (data) => {
          let stateList = data.data;
          if (stateList) {
            stateList.forEach((element: any) => {
              this.stateList.push({
                id: element.id,
                iso_code: element.iso_code,
                state_en: localStorage.getItem('languageCode') == 'ar' ? element.state_name_ar : element.state_name_en
              });
            });
          }
          resolve(this.stateList);
        }
      );
    });
  }

  GetCityList(country: string, searchText: string): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
      this.cityList = [];

      this._apiService.getCityList(country, searchText).subscribe(
        (data) => {
          let cityList = data.data;
          if (cityList) {
            cityList.forEach((element: any) => {
              this.cityList.push({
                id: element.id,
                iso_code: element.iso_code,
                city_en: localStorage.getItem('languageCode') == 'ar' ? element.city_name_ar : element.city_name_en
              });
            });
          }
          resolve(this.cityList);
        }
      );
    });
  }

  GetArabicCountries(): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
      this.arabicCounties = [];

      this._apiService.getArabicCountries('ar').subscribe(
        (data) => {
          let countryList = data.data;
          if (countryList.ArabicSpeakCountries) {
            countryList.ArabicSpeakCountries.forEach((element: any) => {
              this.arabicCounties.push(element);
            });
          }
          resolve(this.arabicCounties);
        }
      );
    });
  }

  getGeoLocationByIP(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
      };

      this._apiService.getGeoLocationByIP(httpOptions).subscribe(
        (data) => {
          var response = data.data[0];
          this.customerRegionCode = response.geoplugin_regionCode;
          this.customerCountryCode = response.geoplugin_countryCode;
          this.customerISDCode = response.isd_code;

          localStorage.setItem('customerRegionCode', this.customerRegionCode);
          localStorage.setItem('customerCountryCode', this.customerCountryCode);
          localStorage.setItem('customerISDCode', this.customerISDCode);
          resolve(true);
        }
      );
    });
  }


}
